import React, { Component } from "react";
import Link from "gatsby-link";
import styled from "styled-components";

export default class MainService extends Component {
  render() {
    const { name, description, tags, img, index } = this.props;
    const Wrap = styled.div`
      background-color: ${props => {
        switch (tags) {
          case "web":
            return props.theme.colors.white;
          case "branding":
            return props.theme.colors.black;
          case "social":
            return props.theme.colors.orange;
          case "copywriting":
            return props.theme.colors.gray;
        }
      }};
      color: ${props => {
        switch (tags) {
          case "web":
            return props.theme.colors.orange;
          case "branding":
            return props.theme.colors.grey;
          case "social":
            return props.theme.colors.white;
          case "copywriting":
            return props.theme.colors.black;
        }
      }};
    `;

    const Item = styled.div`
      font-size: 1.7vw !important;
      line-height: 2ex;
      padding: 0;      
      
    `;

    const ItemForImg = styled.div`
      float: ${index % 2 === 0 ? 'left' : 'right'};
      text-align: ${index % 2 === 0 ? 'left' : 'right'};
      padding: 0;
    `

    const ItemForText = Item.extend`
      text-align: center;
      padding-top: 3vw;
      float: ${index % 2 !== 0 ? 'right' : 'left'};

      @media (max-width: 767px) {
        font-size: 5vw !important;
        padding-bottom: 32px;
      }
    `

    const Img = styled.img`
    `;

    const Name = styled.h3`
      font-size: 3vw;
      position: relative;
      line-height: 1em;
      display: block;
      overflow: hidden;
      margin-bottom: 4vw;
      padding: 0.5vw 0;
      font-family: "Proxima Nova Condensced", sans-serif;
      font-weight: normal;
      font-weight: initial;
      color: currentColor;

      @media (min-width: 1920px) {
        font-size: 57px !important;
      };

      @media (max-width: 767px) {
        font-size: 28px !important;
      }

      &:before,
      &:after {
        content: "";
        position: absolute;
        border: 0.2ex solid transparent;
        border-top-color: inherit;
        width: 25ex;
        transform: translate(-2.5ex) rotate(52deg);
        transform-origin: 0 0;
        overflow: hidden;
        bottom: 3ex;
      }

      &:after {
        transform: translate(-0.4ex) rotate(52deg);
      }
    `;

    const Desc = styled.p`
      margin: 0 auto 4vw;
      max-width: 50%;
      text-align: center;
      font-family: "Proxima Nova Condensced", sans-serif;
      font-weight: initial;

      @media (min-width: 1920px) {
        font-size: 32px !important;
      }

      @media (max-width: 767px) {
        margin-bottom: 32px;
      }
    `;

    const Button = styled(Link)`
      padding: 0.3em 0.8em 0.2em;
      border-width: 3px;
      border-style: solid;
      color: ${props => {
        switch (tags) {
          case "web":
            return props.theme.colors.black;
          case "branding":
            return props.theme.colors.orange;
          case "social":
            return props.theme.colors.grey;
          case "copywriting":
            return props.theme.colors.white;
        }
      }};
      border-color: ${props => {
        switch (tags) {
          case "web":
            return props.theme.colors.black;
          case "branding":
            return props.theme.colors.orange;
          case "social":
            return props.theme.colors.grey;
          case "copywriting":
            return props.theme.colors.white;
        }
      }};

      &:hover {
        color: ${props => {
          switch (tags) {
            case "web":
              return props.theme.colors.white;
            case "branding":
              return props.theme.colors.black;
            case "social":
              return props.theme.colors.orange;
            case "copywriting":
              return props.theme.colors.gray;
          }
        }};
        background-color: ${props => {
          switch (tags) {
            case "web":
              return props.theme.colors.black;
            case "branding":
              return props.theme.colors.orange;
            case "social":
              return props.theme.colors.grey;
            case "copywriting":
              return props.theme.colors.white;
          }
        }};
      }
    `;

    return (
      <Wrap className="row">
        <ItemForImg className="col-sm-6">
          <Img src={img.localFile.childImageSharp.sizes.src} />
        </ItemForImg>
        <ItemForText className={`col-sm-6 content ${tags}`}>
          <Name dangerouslySetInnerHTML={{ __html: name }} />
          <Desc>{description}</Desc>
          <Button to={`/portfolio/#${tags}`}>EXAMPLES</Button>
        </ItemForText>
      </Wrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MainService/index.js